export const IMAGE_EXTENTION = ["jpg", "jpeg", "png"];
